import type { AnchorHTMLAttributes, ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { clsx } from 'clsx';

import { theme } from '@/style/theme';

type LinkProps = {
  to: string;
  children: ReactNode;
  variant?: 'internal' | 'external';
  linkColor?: 'purple' | 'blue' | 'text';
  className?: string;
} & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>;

/** Port of `components/common/Link.tsx`. */
export function Link({
  to,
  children,
  variant = 'internal',
  linkColor = 'purple',
  className,
  ...rest
}: LinkProps) {
  const color =
    linkColor === 'purple'
      ? theme.pageTextLinkLight
      : linkColor === 'blue'
        ? theme.pageTextLink
        : theme.pageText;

  if (variant === 'external') {
    return (
      <a
        href={to}
        target="_blank"
        rel="noreferrer"
        className={clsx('underline-offset-2 hover:underline', className)}
        style={{ color, textDecoration: 'none' }}
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <RouterLink
      to={to}
      className={clsx('hover:underline', className)}
      style={{ color, textDecoration: 'none' }}
      {...rest}
    >
      {children}
    </RouterLink>
  );
}
